// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconXaut } from "../../../icons/full/build/icon-xaut.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const XautIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconXaut.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  XautIcon.displayName = 'XautIcon';
}

export default XautIcon;